import { configApiRef, useApi } from '@backstage/core-plugin-api';
import {
  Content,
  Header,
  Page,
  WarningPanel,
} from '@backstage/core-components';

export const OneUptimePage = () => {
  const embedUrl = useApi(configApiRef).getOptionalString('oneuptime.embedUrl');

  return (
    <Page themeId="tool">
      <Header title="Report an incident" />
      <Content>
        {embedUrl ? (
          <iframe
            title="Report an incident"
            src={embedUrl}
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups"
            style={{ width: '100%', height: '1200px', border: 'none' }}
          />
        ) : (
          <WarningPanel title="oneuptime.embedUrl is not configured" />
        )}
      </Content>
    </Page>
  );
};
